import React from "react";
import Sidebar from "../../components/Sidebar";
import { FailedPayoutTable } from "./components/FailedPayoutTable";

const FailedPayouts = () => {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      <Sidebar />
      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-2">Failed &amp; Refunded Payouts</h1>
        <p className="mb-6 max-w-3xl text-sm text-gray-600">
          Why a payout did not go through. &ldquo;Real cause&rdquo; is what the payment partner or our system recorded;
          &ldquo;Customer was told&rdquo; is the simplified message the customer sees.
        </p>
        <FailedPayoutTable />
      </div>
    </div>
  );
};

export default FailedPayouts;
